import React, { useCallback, useEffect, useState } from 'react';
import ContentContainer from '../../components/containers/ContentContainer';

import Loader from '../../components/loader/Loader';
import RoomGrid from '../../components/room-grid/RoomGrid';
import { getAndReturnData } from '../../context/helperFunctions';
import { motion } from 'framer-motion';
import HeadersContainer from '../../components/headers/headers-container/HeadersContainer';

function Rooms(props) {
    const [roomData, setRoomData] = useState([]);

    const handleError = (err) => {
        console.log(err);
    };

    const getRooms = useCallback(async () => {
        const roomData = await getAndReturnData(
            'api/v1/room?locationId=1',
            handleError
        );

        if (roomData) {
            // Get only rooms that we are able to rent out
            const filteredRoomData = roomData.rooms.filter(
                (room) =>
                    room.id === 1 ||
                    room.id === 11 ||
                    room.id === 5 ||
                    room.id === 9 ||
                    room.id === 10 ||
                    room.id === 12 ||
                    room.id === 13 ||
                    room.id === 14
            );

            const houseData = roomData.rooms.filter((room) => room.id === 26);

            // Separate out room 11
            const room11 = filteredRoomData.find((room) => room.id === 11);

            // Remove room 11 from the list before sorting
            const roomsWithout11 = filteredRoomData.filter(
                (room) => room.id !== 11
            );

            // Sort by area
            const sortedRooms = roomsWithout11.sort((a, b) => b.area - a.area);

            // Insert room 11 at the 5th index (4 because arrays are 0-based)
            if (room11) {
                sortedRooms.splice(3, 0, room11);
            }

            const roomsWithHouse = [...houseData, ...sortedRooms];

            setRoomData(roomsWithHouse);
        }
    }, []);

    useEffect(() => {
        getRooms();
    }, [getRooms]);
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
        >
            <HeadersContainer />

            <ContentContainer>
                {roomData.length > 0 ? (
                    <RoomGrid
                        returnPath="/lokaler"
                        returnTitle="Lokaleoversigt"
                        url={'/lokaler'}
                        data={roomData}
                    />
                ) : (
                    <Loader />
                )}
            </ContentContainer>
        </motion.div>
    );
}

export default Rooms;
